import React, { useContext, useEffect, useState } from 'react';

import {
    Stepper,
    Step,
    StepLabel,
    Typography,
    Link,
    Hidden,
    Grid,
    Button,
    Collapse,
    CircularProgress,
    Tooltip
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import { CustomerRequestContext } from '../CustomerRequestContext';
import { NavContext, NavRoutes } from '../../../contexts';
import { RequestStatus } from '../../../../helpers';
import { makeStyles } from '@material-ui/styles';
import { DbType } from '../../../../helpers/Common';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2)
    },
    history: {
        marginBottom: theme.spacing(1)
    },
    attachments: {
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(1)
    },
    button: {
        width:"100%"
    },
    actionsContainer: {
        display:"flex",
        direction: "row"
    },
    inChargeOf: {
        color: '#c2a07b',
        marginLeft: '8px',
        marginBottom: '8px',
        fontSize: '0.75rem',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: 400,
        lineHeight: 1.66,
        letterSpacing: '0.03333em'
    }
}));

export const RequestStepper = (props) => {
    const classes = useStyles();
    const { navigateTo } = useContext(NavContext);

    const {
        state,
        getLogisitcUsers
    } = useContext(CustomerRequestContext);

    const [isCollapseOpen, setIsCollapseOpen] = useState(false)

    const allSteps = [
        { title: "Draft", status: RequestStatus.Draft },
        { title: "To Be Review", status: RequestStatus.ToBeReviewed },
        { title: "Boss Approval", status: RequestStatus.BossApproval },
        { title: "Credit Risk Evaluation", status: RequestStatus.CreditRiskEvaluation },
        { title: "Credit Risk Re Evaluation", status: RequestStatus.CreditRiskReEvaluation },
        { title: "Credit Risk Approval", status: RequestStatus.CreditRiskApproval },
        { title: "Logistic", status: RequestStatus.Logistic },
        { title: "Waiting For Contract", status: RequestStatus.WaitingForContract },
        { title: "Account Receivable Approval", status: RequestStatus.AccountReceivableApproval },
        { title: "Waiting To Be Added In Sap", status: RequestStatus.WaitingToBeAddedInSap },
        { title: "Sap Error", status: RequestStatus.SapError },
        { title: "Blocked", status: RequestStatus.Blocked },
        { title: "Closed", status: RequestStatus.Closed },
        { title: "Approved", status: RequestStatus.Approved }
    ];

    const filterSteps = () => {
        //Remember to remove steps backward in this way every remove is not affected by the index change on removal
        let steps = [ ...allSteps ];

        switch(state.request.status) {
            case RequestStatus.ToBeReviewed:
                steps.splice(10, 3);
                steps.splice(4, 1);
                steps.splice(0, 1);
                break;

            case RequestStatus.CreditRiskReEvaluation:
                steps.splice(10, 3);
                steps.splice(3, 1);
                steps.splice(0, 1);
                break;

            case RequestStatus.SapError:
                steps.splice(11, 2);
                steps.splice(9, 1);
                steps.splice(0, 1);
                break;

            case RequestStatus.Blocked:
            case RequestStatus.Closed:
                steps.splice(13, 1);
                steps.splice(4, 7);
                steps.splice(1, 1);
                break;

            default:
                steps.splice(10, 3);
                steps.splice(4, 1);
                steps.splice(1, 1);
                break;
        }

        //adding Pricing Unit step
        if (
            state.request.dbType === DbType.S4 &&
            state.request.status !== RequestStatus.Blocked &&
            state.request.status !== RequestStatus.Closed
        ){
            let arrayIndex;

            if (state.request.status === RequestStatus.SapError)
                arrayIndex = 7;
            else
                arrayIndex = 6;

            const pricingUnitStep = {
                title: "Pricing Unit",
                status: RequestStatus.PricingUnit
            };

            steps.splice(arrayIndex,0,pricingUnitStep);
        }

        return steps;
    }

    const getSteps = () => {
        return filterSteps().map((step) =>
            <Step key={step.title} color="primary">
                <StepLabel>{step.title}</StepLabel>
            </Step>
        );
    }

    const [activeStep, setActiveStep] = useState(0);
    useEffect(() => {
        const index = filterSteps().findIndex((step) => step.status === state.request.status);        
        setActiveStep(index);
    }, [state.request.status]);

    const [isTooltip, setIsTooltip] = useState(false);

    const [allInvolvedLogistics, setAllInvolvedLogistics] = useState([]);

    useEffect(() => {
        if (state.logisticUsers.length > 0){
            const involvedUsersInfo = [];
    
            state.logisticUsers.map(user => {
                const splitUser = user.split(" (");
                const userObject = {
                    name: splitUser[0],
                    role: splitUser[1].replace(")", "")
                };
                involvedUsersInfo.push(userObject);
            });
        
            involvedUsersInfo.sort((a, b) => a.role > b.role ? 1 : -1);
            
            const usersWithRoleTitle = involvedUsersInfo.map((user, index) => {
                return (
                    <>
                        {
                            (index !== 0 && involvedUsersInfo[index].role !== involvedUsersInfo[index - 1].role) &&
                            <Typography component="div" style={{color: 'transparent'}}>-</Typography>
                        }
                        
                        {
                            (index === 0 || involvedUsersInfo[index].role !== involvedUsersInfo[index - 1].role) &&
                            <Typography component="div">
                                {user.role.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()) + ":"}
                            </Typography>
                        }
    
                        <Typography component="div">
                            {user.name}
                        </Typography>
                    </>
                );
            });
    
            setAllInvolvedLogistics(usersWithRoleTitle);
        }
    }, [state.logisticUsers.length]);

    return (
        <div className={classes.root}>
            <div className={classes.actionsContainer}>
                {state.request.status !== RequestStatus.Draft &&
                    <Link
                        component="button"
                        variant="caption"
                        className={classes.history}
                        onClick={() => {
                            navigateTo(NavRoutes.RequestHistory, [state.request.customerRequestId])
                        }}>
                        View request history
                    </Link>            
                }
                {state.request.sharepointFolderUrl &&
                    <Link
                        target="_blank" 
                        rel="noopener"
                        variant="caption"
                        className={classes.attachments}
                        href={state.request.sharepointFolderUrl}>
                        See attachments
                    </Link>
                }
                {state.request.status === RequestStatus.Logistic &&
                    <>
                        {
                            state.logisticUsers.length === 0 &&
                            !state.loadingLogisticUsers &&
                            <div
                                className={classes.inChargeOf}
                                style={{ cursor: 'pointer' }}
                                onClick={async () =>
                                    state.logisticUsers.length === 0 &&
                                    await getLogisitcUsers(state.request.customerRequestId, state.request.status, state.request.dbType)
                                }
                            >In charge of</div>
                        }
                        {
                            state.loadingLogisticUsers ?
                            <CircularProgress
                                size="20px"
                                style={{ marginLeft: '20px' }}
                            /> :
                            <>
                                {
                                    state.logisticUsers.length > 0 &&
                                    <Tooltip
                                        open={isTooltip}
                                        title={allInvolvedLogistics} 
                                        aria-label="people" 
                                        arrow
                                        enterTouchDelay={1}
                                        onOpen={() => setIsTooltip(true)}
                                        onClose={() => setIsTooltip(false)}
                                    >
                                        <div
                                            className={classes.inChargeOf}
                                            style={{ cursor: 'default' }}
                                        >In charge of</div>
                                    </Tooltip>
                                }
                            </>
                        }
                    </>
                }
            </div>
            <Hidden mdUp>
                <Grid container>
                    <Grid item xs={12} md={12}>
                        <Button
                            className={classes.button}
                            variant="outlined"
                            color="primary"
                            onClick={() => setIsCollapseOpen(!isCollapseOpen)}
                            endIcon={isCollapseOpen ? <ArrowDropUpIcon/> : <ArrowDropDownIcon/>}>
                            Request status
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Collapse in={isCollapseOpen}>
                            <Stepper orientation="vertical" activeStep={activeStep}>
                                {getSteps()}
                            </Stepper>
                        </Collapse>
                    </Grid>
                </Grid>
            </Hidden>
            <Hidden smDown>
                <Stepper alternativeLabel activeStep={activeStep}>
                    {getSteps()}
                </Stepper>
            </Hidden>            
        </div>
    );
}
